var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumDifficultyLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.115051,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#FFF3E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_233_3390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.34794 18.5498V14.1672C8.34794 13.5933 7.87838 13.1237 7.30446 13.1237C6.73055 13.1237 6.26099 13.5933 6.26099 14.1672V18.5498C6.26099 19.1237 6.73055 19.5933 7.30446 19.5933C7.87838 19.5933 8.34794 19.1237 8.34794 18.5498Z",
    fill: "#FAA53D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6521 18.5496C15.6521 19.1235 16.1217 19.5931 16.6956 19.5931C17.2695 19.5931 17.7391 19.1235 17.7391 18.5496V5.68001C17.7391 5.1061 17.2695 4.63654 16.6956 4.63654C16.1217 4.63654 15.6521 5.1061 15.6521 5.68001V18.5496Z",
    fill: "#FFD39E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 9.92348V18.5496C13.0435 19.1235 12.5739 19.593 12 19.593C11.4261 19.593 10.9565 19.1235 10.9565 18.5496V9.92348C10.9565 9.34957 11.4261 8.88 12 8.88C12.5739 8.88 13.0435 9.34957 13.0435 9.92348Z",
    fill: "#FAA53D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_3390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4.11505)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumDifficultyLevel);
export default __webpack_public_path__ + "static/media/medium-difficulty-level.7b58e6862405ac38e478604477c6c10a.svg";
export { ForwardRef as ReactComponent };